import React, { useEffect, useState, useRef, useCallback, useContext } from "react";
import { renderToString } from 'react-dom/server';
import { connect, useDispatch } from "react-redux";
import { ContentLabel, CardTag, StopWatch, UserThumbnails, LoadSpinner } from '../../../../components';
import { dateTimeFormatter, formatDay, monthAbbrev } from '../../../../utils';
import Calendar from '@toast-ui/react-calendar';
import { Button, Row, Col, Spinner } from "react-bootstrap";
import { content_groupActions, alertActions } from "../../../../actions";
import '@toast-ui/calendar/dist/toastui-calendar.css';
import DesktopCalendarCard from './desktopCalendarCard.js';
import { WorkspaceShowContext } from "../../../../contexts/WorkspaceShowContext.js";
import { isToday } from "../../../../helpers/isToday.js";
import useIsCardVisited from "../../../../hooks/useIsCardVisited.js";

function DesktopCalendar(props) {
  const {
    workspace_id,
    date,
    setDate,
    onSelectDateTime,
    calendarRef,
    events,
    onClickEvent,
    custom_close_button_id_text,
    can_access_edit_label,
    can_access_move_content_calendar,
    content_group_loading,
    can_access_clone_content_group,
    can_access_content_destroy,
    can_access_content
  } = props
  const dispatch = useDispatch();

  const {
    organization_id
  } = useContext(WorkspaceShowContext);

  const {
    isCardVisited
  } = useIsCardVisited();
 
  useEffect(() => {
    if(calendarRef.current){
      const calendarInstance = calendarRef.current.getInstance();

      calendarInstance.setDate(date);
      calendarInstance.render();
    }
  }, [calendarRef.current]);

  //const black = '#0F172A';
  const black = 'red'

  const themeConfig = {
    common:{
      holiday:{
        color: black,
      },
      backgroundColor: 'white',
    },
    month:{
      dayName: {
        borderLeft: '0',
        backgroundColor: '#f2f2f2',
        fontSize: 10
      },
      holidayExceptThisMonth: {
        color: black
      },
      dayExceptThisMonth: {
        color: black
      }
    },
    week: {
      daygrid: {
        borderLeft: '5px solid #F2F2F2',
      },
    }
  };

  const mapSchedule = (items) => {
    return items?.map(item => (
      item.due_date && {
        id: item.id,
        title: item.name,
        raw: {
          labels: item.labels,
          due_date: item.due_date,
          reminder_in_day: item?.reminder_in_day,
          completed: item?.completed,
          drafts: item?.drafts,
          stage: item?.stage,
          timestamp_info: item?.timestamp_info,
          unread_comments: item?.unread_comments,
          visited: isCardVisited(item.id)
        },
        category: 'time',
        calendarId: 1,
        start: item.due_date && dateTimeFormatter(item.due_date, 'input'),
        end: item.due_date && dateTimeFormatter(item.due_date, 'input'),
        isReadOnly: false
      }
    )).filter(item => !!item);
  }

  const handleClickTodayButton = () => {
    const calendarInstance = calendarRef.current.getInstance();

    calendarInstance.today();
    setDate(calendarInstance.getDate().d.toLocaleString());
  }

  const handleClickPrevButton = () => {
    const calendarInstance = calendarRef.current.getInstance();

    calendarInstance.prev();
    setDate(calendarInstance.getDate().d.toLocaleString());
  }

  const handleClickNextButton = () => {
    const calendarInstance = calendarRef.current.getInstance();

    calendarInstance.next();
    setDate(calendarInstance.getDate().d.toLocaleString());
  }

  const handleClickRenderButton = () => {
    const calendarInstance = calendarRef.current.getInstance();

    calendarInstance.render();
  }

  const updateContentGroup = (schedule, changes) => {
    let contentGroupId = schedule.id;

    const callback = () => {
      handleClickRenderButton();
    }

    let values = { content_group: { dueDate: "" + changes.end.d } };
    dispatch(content_groupActions.updateContentGroup(values, contentGroupId, workspace_id, callback));
  };

  const onBeforeUpdateEvent = function(event) {
    if(can_access_move_content_calendar) {
      var schedule  = event.event;
      var changes = event.changes;

      if(schedule.end.d.d.toLocaleDateString() === changes.end.d.d.toLocaleDateString()) return;

      updateContentGroup(schedule, changes);
    }else {
      dispatch(alertActions.error("You are not authorized to access this page"));
    }
  }

  const handleSeeMoreEvents = (date) =>{
    const { top, height, left } = date.target.getBoundingClientRect();

    const { innerWidth, innerHeight } = window;
    const padding = top - innerHeight;

    if(top < 0){
      return date.target.style.top = '51px';
    }

    if(innerHeight <= top + height){
      const beta_sum = top - (height + padding + 35);
      if(beta_sum >0) {
        return date.target.style.top = beta_sum + 'px';
      } else{
        return date.target.style.top = top - (height) + 'px';
      }
    }
  }

  const dayFullNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return (
      <>
        <div className="calendar-button_group layout__adaptive-wrapper bg-white d-flex align-items-center justify-content-between">
          <h2 id="renderRange" className="render-range calendar__month ms-4 mb-0">{ dateTimeFormatter(date, 'calendar_month')}</h2>

          <div md="5" lg="3" className={"d-flex justify-content-end"}>
            <Button variant="transparent" onClick={handleClickPrevButton} className="mx-1"><i className="fa fa-angle-left" aria-hidden="true"></i></Button>
            <Button variant="" onClick={handleClickTodayButton} className="mx-1 btn-today">This Month</Button>
            <Button variant="transparent" onClick={handleClickNextButton} className="mx-1"><i className="fa fa-angle-right" aria-hidden="true"></i></Button>
          </div>
        </div>

        <div
          className={`calendar-wrapper position-relative ${content_group_loading && 'loading'}`}
          style={{ overflowY: "auto" }}
        >

          {
            content_group_loading &&
            <LoadSpinner fullscreen={true} />
          }

          <div className="py-2 px-4">
            <Calendar
              isReadOnly={!can_access_move_content_calendar || content_group_loading}
              useDetailPopup={false}
              onSelectDateTime={onSelectDateTime}
              onBeforeUpdateEvent={onBeforeUpdateEvent}
              month={{
                visibleEventCount: 1
              }}
              usageStatistics={false}
              ref={calendarRef}
              height="900px"
              events={ mapSchedule(events) }
              view= {'month'}
              gridSelection={{
                enableClick: can_access_content && !content_group_loading,
                enableDblClick: false
              }}
              taskView={true}
              theme={themeConfig}
              eventView={true}
              onClickEvent={onClickEvent}
              onClickMoreEventsBtn={handleSeeMoreEvents}
              template= {{
                monthDayName: function(dayname) {
                  return `<span class="tui-full-calendar-weekday-grid-date">${dayFullNames[dayname.day]}</span>`;
                },
                monthGridHeader: (model) => {
                    var date = new Date(model.date);

                    var todayClass = isToday(date) ? 'toastui-calendar-weekday-grid-date toastui-calendar-weekday-grid-date-decorator toastui-calendar-template-monthGridHeader' : '';
                    const dateNum = date.getDate()

                    const month = dateNum === 1 ? '<span class="me-1">' + monthAbbrev(date.getMonth()) + '</span>' : '';

                    const addCardButton = can_access_content ? '<button class="add-card-button btn ms-2 btn-dashed badge rounded-pill">Add Card</button>' : ''

                    var template = '<span class="tui-full-calendar-weekday-grid-date ">'+ month +'<span class="'+ todayClass +'">' + date.getDate() + '</span> ' + addCardButton + '</span>';
                    return template;
                },
                time(schedule) {
                  let projectLabels = schedule.raw?.labels.map((label, index) => (
                    renderToString(
                      <ContentLabel
                        id={label.id}
                        custom_close_button_id_text={custom_close_button_id_text}
                        editable={can_access_edit_label && !content_group_loading}
                        name={label.name}
                        color_hex={label.color_hex}
                        custom_close_button_bg_color={"#E9E8F5"}
                      />
                    )
                  )).join('');

                  let default_string = renderToString(
                      <DesktopCalendarCard 
                        schedule={schedule}
                        can_destroy={can_access_content_destroy}
                        can_clone={can_access_clone_content_group}
                        can_update={can_access_content}
                      />
                  )

                  let stopwatch = schedule.raw?.stage?.enable_timestamp && !schedule.raw?.stage?.approved ? (
                    renderToString( 

                      <div className="d-flex align-items-center">
                        <StopWatch
                          initialTime={schedule?.raw?.timestamp_info?.latest_change_total_seconds || 0}
                          initialStartDate={schedule?.raw?.timestamp_info?.latest_start}
                          isActive={schedule?.raw?.enable_timestamp && schedule?.raw?.timestamp_info?.active}
                          viewMode={'CALENDAR'}
                          className={"d-xxl-inline-flex mx-1"}
                        />
                      </div>
                  
                    )
                  ) : null;

                  if(stopwatch && projectLabels){
                    default_string = default_string + "<div class='d-xxl-flex justify-content-between align-items-center'><div class='calendar__project-labels "+ (stopwatch ? 'd-xxl-inline-flex' : '') +"'>" + projectLabels + "</div>"+ stopwatch +"</div>";
                  } else {
                    if(projectLabels){
                      default_string = default_string + "<div class='calendar__project-labels "+ (stopwatch ? 'd-xxl-inline-flex' : '') +"'>" + projectLabels + "</div>";
                    }

                    if (stopwatch){
                      default_string = default_string + stopwatch;
                    }
                  }


                  return default_string;
                },
                allday(schedule) {
                  return "<span>foo</span>"; //JSON.stringify(schedule);
                },
                popupDetailDate(isAllDay, start, end) {
                  var end_date = new Date(end).toISOString();
                  return ("Due date: "+ dateTimeFormatter(end_date, 'calendar_date_time'));
                },
              }}
            />
          </div>
        </div>
      </>
  );
}


const mapStateToProps = (state) => {
  return {
    loading: state.work_space.loading,
    content_group_loading: state.content_group.content_group_loading,
    can_access_move_content_calendar: state.work_space.can_access_move_content_calendar,
    can_access_content_destroy: state.work_space.can_access_content_destroy,
    can_access_content: state.work_space.can_access_content,
    can_access_clone_content_group: state.work_space.can_access_clone_content_group,
  };
};

export default connect(mapStateToProps, {  })(DesktopCalendar);
